import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminCampaigns = lazy(() => import("@/pages/admin/AdminCampaigns"));

export const Route = createFileRoute("/admin/kampanjer")({
  component: () => <AdminCampaigns />,
});
